import { Component, SecurityContext, ViewChild } from '@angular/core';
import { MaintenanceService } from '../../../services/maintenanceService';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DailogModalComponent } from '../../../../shared/elements/dailog-modal/dailog-modal.component';
import { ToastrService } from 'ngx-toastr';
import { DigitFormatterPipe } from '../../../../shared/pipe/digit-formatter.pipe';
import { environment } from '../../../../../environments/environment';
import { ExportDataService } from '../../../../shared';
import { ActivatedRoute } from '@angular/router';
import { MatExpansionPanel } from '@angular/material/expansion';
import * as _ from 'lodash';
import { DomSanitizer } from '@angular/platform-browser';
import { ReportsService } from '../../../../reports/reports.service';
import { SharedAuthService } from '../../../../shared/shared.auth.service';
@Component({
  selector: 'app-forecast-management-service-detail',
  templateUrl: './forecast-management-service-detail.component.html',
  styleUrl: './forecast-management-service-detail.component.scss',
  standalone: false
})
export class ForecastManagementServiceDetailComponent {
  displayedColumns: string[] = [
    'Year',
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ];
  months: string[] = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  panelOpenState: boolean = true;
  inEditMode: boolean = true;
  showCharge: boolean = false;
  currentMode: string = 'normal';
  chargeFCdataSource = {};
  forecastComments: string = '';
  volumeFCdataSource = {};
  chargeACdataSource = [];
  volumeACdataSource = [];
  editedYrs = [];
  currentYear: any;
  masterData: any = {};
  dataSource: any;
  SO_Edit: string[] = [];
  AO_AD_Edit: string[] = [];
  FA_SFA_Edit: string[] = [];
  loggedInUser: string;
  currentFC: any;
  previousFC: any;
  fcDataSource: any;
  showLoader: boolean;
  valueExceedLmt: any = [];
  comments: string = '';
  appId: string;
  service: string;
  maxrange: number;
  chartData: any = [];
  formatResponse: any = {};
  maxDate: any;
  minDate: any;
  APIresponse: any = {};
  FCCycle: string[];
  currentMonth: number;
  label: string;
  temp: any = {};
  Edit_TOH: any = 'no';
  decomStartMnth: number;
  decomStartYear: number;
  decomMonths: string[];
  decomFCFlag: boolean;
  fcDecomCount: any;
  minrange: number;
  fc_start_mnth: number;
  initialVal = { Jan: 0, Feb: 0, Mar: 0, Apr: 0, May: 0, Jun: 0, Jul: 0, Aug: 0, Sep: 0, Oct: 0, Nov: 0, Dec: 0 };
  @ViewChild('attestationPopup', { static: false }) attestationPopup: any;
  attestation_popup_title: string;
  decomcount: any = 0;
  commentsPlaceholderText: string;
  lastModified: boolean = false;
  @ViewChild('panel') panel: MatExpansionPanel;
  excelChargeACdataSource: any;
  excelvolumeACdataSource: any;
  excelvolumeFcdataSource: any;
  excelChargeFCdataSource: any;
  availableData: any;
  isForecastAdmin: boolean = false;
  isForecastSRM: boolean = false;
  Admin_Edit_TOH: any;
  allowNegative: boolean = false;
  newcomments: any = '';
  forecastCycleType:any = null;
  chargeProjectionDataSource: any[];

  constructor(
    public exportService: ExportDataService,
    public maintenanceService: MaintenanceService,
    public dialog: MatDialog,
    private toaster: ToastrService,
    private digitFormatter: DigitFormatterPipe,
    private activatedRoute: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private ReportsService: ReportsService,
    private sharedAuthService: SharedAuthService
  ) {}
  ngOnInit() {
    this.currentMonth = new Date().getMonth();
    this.loggedInUser = this.sharedAuthService.getMsid();
    this.activatedRoute.queryParams.subscribe(data => {
      this.appId = data['appId'] ? data['appId'] : null;
      this.service = data['service'] ? data['service'] : null;
      this.allowNegative = this.appId ? this.appId.toLocaleLowerCase().includes('topsides') : false;
    });

    setTimeout(() => {
          const config = sessionStorage.getItem('config');
        if (config) {
          const parsedConfig = JSON.parse(config);
          this.availableData = parsedConfig?.avialableData || null; // Corrected spelling and added null check
        } else {
          this.availableData = null;
        }
        if (!this.availableData) {
          console.error('availableData is null or undefined');
          this.showLoader = false;
          this.showErrMsg('Configuration data is missing. Please refresh the page or contact support.');
          return;
        }
        this.getServiceDtl();
        }, 4000);


    this.getForecastOwnerDetails();
  }

  togglePanel(event: Event, panel: MatExpansionPanel) {
    event.stopPropagation();
    panel.toggle();
  }
  getServiceDtl() {
    const params = {
      appId: this.appId,
      service: this.service
    };
    this.showLoader = true;
    this.maintenanceService.getFCServiceDtl(params).subscribe(
      (response: any) => {
        response = this.getChargesForProjections(response);
        this.APIresponse = response;
        this.showLoader = false;
        this.currentFC = response.forecast.filter(x => x.Previous.toLowerCase() == 'no')[0];
        this.previousFC = response.forecast.filter(x => x.Previous.toLowerCase() == 'yes')[0];
        if (this.currentFC?.FC_Start_Month) {
          const getMonthNumber = monthName => new Date(`${monthName} 1, ${this.currentYear}`).getMonth() + 1;
          const fcStartMonthParts = this.currentFC.FC_Start_Month.split(',');
          if (fcStartMonthParts.length > 1) {
            this.fc_start_mnth = getMonthNumber(fcStartMonthParts[1]);
          } else {
            console.error('FC_Start_Month format is invalid');
            this.fc_start_mnth = null;
          }
        } else {
          console.error('FC_Start_Month is undefined for currentFC');
          this.fc_start_mnth = null;
        }

        this.currentYear = this.currentFC?.Forecast_Year;
        this.masterData = response.service.current[this.currentYear];
        this.getForeCastCycleType(this.currentFC);
        this.AO_AD_Edit =
          this.masterData?.AO_AD_Edit && this.masterData.AO_AD_Edit != null
            ? this.masterData.AO_AD_Edit.split(',')
            : [];
        this.FA_SFA_Edit =
          this.masterData?.FA_SFA_Edit && this.masterData.FA_SFA_Edit != null
            ? this.masterData.FA_SFA_Edit.split(',')
            : [];
        this.SO_Edit =
          this.masterData?.SO_Edit && this.masterData.SO_Edit != null ? this.masterData.SO_Edit.split(',') : [];
        this.Edit_TOH =
          this.masterData?.Edit_TOH && this.masterData.Edit_TOH != null ? this.masterData.Edit_TOH.toLowerCase() : 'no';
        this.Admin_Edit_TOH =
          this.masterData?.Admin_Edit_TOH && this.masterData.Admin_Edit_TOH != null
            ? this.masterData.Admin_Edit_TOH.toLowerCase()
            : 'no';
        this.dataSource = response.service;

        this.fcDataSource = JSON.parse(JSON.stringify(response));
        this.currentYear = Number(this.currentYear);
        this.forecastComments = this.masterData?.Comments || '';
        this.chargeACdataSource = this.formatActualSource(response.service.current, 'charge');
        this.chargeACdataSource = this.calculateTotal(this.chargeACdataSource, 'charge');
        this.volumeACdataSource = this.formatActualSource(response.service.current, 'volume');
        this.volumeACdataSource = this.calculateTotal(this.volumeACdataSource, 'volume');
        this.excelChargeACdataSource = JSON.parse(JSON.stringify(this.chargeACdataSource));
        this.excelvolumeACdataSource = JSON.parse(JSON.stringify(this.volumeACdataSource));
        this.chargeProjectionDataSource = this.formatActualSource(response.service.projections, 'volume');
        this.chargeProjectionDataSource = this.calculateTotal(this.chargeProjectionDataSource, 'volume');
        if (this.masterData?.decom_date && this.masterData.decom_date != null) {
          this.decomStartMnth = new Date(this.masterData.decom_date).getMonth();
          this.decomStartYear = new Date(this.masterData.decom_date).getFullYear();
        }

        this.decomMonths = this.months.slice(this.decomStartMnth + 1);
        this.formatFCSource(response);
        this.excelvolumeFcdataSource = JSON.parse(JSON.stringify(this.volumeFCdataSource));
        this.excelChargeFCdataSource = JSON.parse(JSON.stringify(this.chargeFCdataSource));
        this.updategraph(response);
        this.lastModified = response.service.updated_By && response.service.updated_At ? true : false;
        this.showLoader = false;
      },
      error => {
        this.showLoader = false;
        this.showErrMsg(error);
      }
    );
  }
  getChargesForProjections(response: any): any {
    if(response.service?.projections && Object.keys(response.service.projections).length > 0){
      const projections = response.service.projections;
      Object.keys(projections).forEach(year => {
          const rate = response.service.current[year]?.CY_Rate || 0;
          const unitOfMeasure = response.service.current[year]?.Unit_Of_Measure || '';
          const charge = {};
          Object.keys(projections[year].volume).forEach(month => {
            const volumeValue = projections[year].volume[month] || 0;
            charge[month] = rate * volumeValue.toFixed(0);
          });
          projections[year].charge = charge;
          projections[year].CY_Rate = rate;
          projections[year].Unit_Of_Measure = unitOfMeasure;
      });
    }else{
      response.service.projections = {};
      // i need to get the year from response.service.current and assign  it to projections with intial values
      const currentYears = Object.keys(response.service.current);
      currentYears.forEach(year => {
        response.service.projections[year] = {
          charge: this.initialVal,
          volume: this.initialVal,
          CY_Rate: response.service.current[year]?.CY_Rate || 0,
          Unit_Of_Measure: response.service.current[year]?.Unit_Of_Measure || ''
        };
      });
    }
    return response;
  }

  checkDecomFCData() {
    if (
      this.masterData?.decom_date != null &&
      this.volumeFCdataSource &&
      Object.keys(this.volumeFCdataSource).length > 0
    ) {
      let count = 0;
      Object.keys(this.volumeFCdataSource).forEach(yr => {
        this.volumeFCdataSource[yr].forEach(element => {
          const yr = element.Year.split('(')[0];
          if (element.cycle == 'current' && yr == this.decomStartYear) {
            this.decomMonths.forEach(mnth => {
              const val = this.allowNegative
                ? element[mnth].toLocaleString().replace(/(?!^)-|[^0-9-]/g, '')
                : element[mnth].toLocaleString().replace(/[^0-9]*/g, '');
              Number(val) > 0 ? count++ : count;
            });
          } else if (element.cycle == 'current' && yr > this.decomStartYear) {
            this.months.forEach(mnth => {
              const val = this.allowNegative
                ? element[mnth].toLocaleString().replace(/(?!^)-|[^0-9-]/g, '')
                : element[mnth].toLocaleString().replace(/[^0-9]*/g, '');
              Number(val) > 0 ? count++ : count;
            });
          }
        });
      });
      return count > 0 ? true : false;
    } else {
      return false;
    }
  }

  checkDecomFCMonth(element, column) {
    if (this.masterData?.decom_date != null && element[column] != '') {
      const count = 0;
      const yr = element.Year.split('(')[0];
      if (element.cycle == 'current' && yr == this.decomStartYear && this.decomMonths.includes(column)) {
        const val = this.allowNegative
          ? element[column].toLocaleString().replace(/(?!^)-|[^0-9-]/g, '')
          : element[column].toLocaleString().replace(/[^0-9]*/g, '');
        return Number(val) > 0 ? true : false;
      } else if (element.cycle == 'current' && yr > this.decomStartYear) {
        const val = this.allowNegative
          ? element[column].toLocaleString().replace(/(?!^)-|[^0-9-]/g, '')
          : element[column].toLocaleString().replace(/[^0-9]*/g, '');
        return Number(val) > 0 ? true : false;
      }
      return count > 0 ? true : false;
    } else {
      return false;
    }
  }

  info() {
    window.open(environment.docUrl + 'user-guide/Forecast-Management/');
  }
  updategraph(response) {
    this.formatResponse = this.formatDataForGraph(response);
    this.label = this.showCharge ? 'Charge' : 'Volume';
    this.chartData = this.formatResponse['arr'] == undefined ? [] : this.formatResponse['arr'];
    this.maxrange = this.formatResponse['maxRange'] == undefined ? 0 : this.formatResponse['maxRange'];
    this.minrange = this.formatResponse['minValue'] == undefined ? 0 : this.formatResponse['minValue'];
    this.maxDate = this.formatResponse['xMaxDate'] == undefined ? new Date() : this.formatResponse['xMaxDate'];
    this.minDate = this.formatResponse['xMinDate'] == undefined ? new Date() : this.formatResponse['xMinDate'];
  }

  checkBtnDisability() {
    return (
      (this.valueExceedLmt.length > 0 && this.newcomments == '') || (this.decomcount > 0 && this.newcomments == '')
    );
  }

  excelDownload() {
    if (!this.dataSource || !this.dataSource.current || !this.currentYear) {
      this.toaster.error('Data is not available for export', '', {
        timeOut: 10000,
        positionClass: 'toast-top-center'
      });
      return;
    }
  
    let volumeData = [];
    let chargeData = [];
    const cy = 'Rate ' + this.currentYear + '/UOM ' + this.currentYear;
    const py = 'Rate ' + (this.currentYear - 1) + '/UOM ' + (this.currentYear - 1);
    const fy = 'Rate ' + (this.currentYear + 1) + '/UOM ' + (this.currentYear + 1);
    const serviceData = {
      'Application Id': this.dataSource?.app_id,
      'Application Name': this.dataSource?.app_name,
      'Service Id': this.dataSource?.service,
      'Service Name': this.dataSource?.SV_Desc
    };
    serviceData[py] = this.dataSource.current[this.currentYear - 1]?.CY_Rate
      ? this.dataSource.current[this.currentYear - 1].CY_Rate +
        '/' +
        this.dataSource.current[this.currentYear - 1].Unit_Of_Measure
      : 'NA';
    serviceData[cy] = this.dataSource.current[this.currentYear]?.CY_Rate
      ? this.dataSource.current[this.currentYear].CY_Rate +
        '/' +
        this.dataSource.current[this.currentYear].Unit_Of_Measure
      : 'NA';
    serviceData[fy] = this.dataSource.current[this.currentYear + 1]?.CY_Rate
      ? this.dataSource.current[this.currentYear + 1]?.CY_Rate +
        '/' +
        this.dataSource.current[this.currentYear + 1].Unit_Of_Measure
      : 'NA';
    this.addServiceData(serviceData, this.excelChargeACdataSource, 'AC', 'charge');
    this.addServiceData(serviceData, this.excelChargeFCdataSource['firstTable'], 'FC', 'charge');
    this.addServiceData(serviceData, this.excelChargeFCdataSource['secondTable'], 'FC', 'charge');
    this.addServiceData(serviceData, this.excelvolumeACdataSource, 'AC', 'volume');
    this.addServiceData(serviceData, this.excelvolumeFcdataSource['firstTable'], 'FC', 'volume');
    this.addServiceData(serviceData, this.excelvolumeFcdataSource['secondTable'], 'FC', 'volume');
    const chargeToExport = [];
    Object.keys(this.excelChargeFCdataSource).forEach(element => {
      this.excelChargeFCdataSource[element].forEach(eachYr => {
        if (eachYr.label != 'Variance') {
          const tempObj = eachYr;
          delete tempObj['label'];
          delete tempObj['tooltip'];
          delete tempObj['tableName'];
          chargeToExport.push(tempObj);
        }
      });
    });
    chargeData = JSON.parse(JSON.stringify([...this.excelChargeACdataSource, ...chargeToExport]));
    chargeData.forEach(x => {
      delete x.cycle;
      delete x.orgTotal;
      x.total = '$' + x.total;
      Object.keys(x).forEach(key => {
        x[key] = String(x[key]);
      });
    });
    const volumeToExport = [];
    Object.keys(this.excelvolumeFcdataSource).forEach(element => {
      this.excelvolumeFcdataSource[element].forEach(eachYr => {
        if (eachYr.label != 'Variance') {
          const tempObj = eachYr;
          delete tempObj['label'];
          delete tempObj['tooltip'];
          delete tempObj['tableName'];
          volumeToExport.push(tempObj);
        }
      });
    });
    volumeData = JSON.parse(JSON.stringify([...this.excelvolumeACdataSource, ...volumeToExport]));
    volumeData.forEach(x => {
      delete x.cycle;
      delete x.orgTotal;
      Object.keys(x).forEach(key => {
        x[key] = String(x[key]);
      });
    });
    this.exportService.exportToExcel(
      'Forecast Management Service - ' + this.dataSource?.app_name + ' - ' + this.dataSource?.SV_Desc,
      [volumeData, chargeData],
      ['Volume Data', 'Charge Data']
    );
  }

  addServiceData(serviceData, dataSource, type, dataType) {
    dataSource.forEach((element, index) => {
      const roundedObj = {};
      for (const key in element) {
        if (this.months.includes(key)) {
          roundedObj[key] = this.convertToNumber(element[key]);
          roundedObj[key] =
            dataType == 'charge'
              ? '$' + roundedObj[key].toLocaleString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              : roundedObj[key];
        } else if (key == 'Year' && type == 'AC') {
          roundedObj[key] = element[key] + '(Actuals)';
        } else {
          roundedObj[key] = element[key];
        }
      }
      const combinedObj = { ...serviceData, ...roundedObj };
      dataSource[index] = combinedObj;
    });
  }

  formatActualSource(datasource, type) {
    const source = JSON.parse(JSON.stringify(datasource));
    const array = [];
    let actualData = {};
    const availableMnth = this.availableData.split(' ')[0];
    const availableYr = this.availableData.split(' ')[1];
    const availabledataMonths = JSON.parse(JSON.stringify(this.months));
    availabledataMonths.splice(availabledataMonths.indexOf(availableMnth) + 1, 12);
    if (this.currentYear - 1 < availableYr) {
      actualData = { Year: this.currentYear - 1, ...source[this.currentYear - 1][type] };
      array.push(actualData);
    }
    if (this.currentYear < availableYr) {
      actualData = { Year: this.currentYear, ...source[this.currentYear][type] };
      array.push(actualData);
    }
    if (this.currentYear - 1 == availableYr || this.currentYear == availableYr) {
      const filteredObj = Object.keys(source[availableYr][type])
        .filter(key => availabledataMonths.includes(key))
        .reduce((acc, key) => {
          acc[key] = source[availableYr][type][key] ? source[availableYr][type][key] : 0;
          return acc;
        }, {});

      if (Object.keys(filteredObj).length > 0) {
        actualData = { Year: availableYr, ...filteredObj };
        array.push(actualData);
      }
    }
    return array;
  }

  //Function to calculate sum of all values aand add it in form of key for charge and volume
  calculateTotal(arr: Array<any>, _type) {
    try {
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const result = arr.map(item => {
        const total = this.calculateMonthlyTotal(item, months);
        const orgTotal = _.cloneDeep(total);
        return { ...item, total, orgTotal };
      });
      return result;
    } catch (error) {
      console.error('Error calculating total:', error);
      return arr;
    }
  }

  //Function to calculate the sum of all values for each month
  private calculateMonthlyTotal(item: any, months: string[]): number {
    return months.reduce((total, month) => {
      let value = item[month];
      if (typeof item[month] == 'string') {
        value = item[month].replace(/,/g, ''); //If value is in string format then remove the comma
      }
      const no = Number(value) || 0;
      return total + Number(this.formatNumber(no));
    }, 0);
  }

  //Function to round off the number
  formatNumber(value: number) {
    return Math.round(value);
  }

  formatFCSource(datasource) {
    const fc = JSON.parse(JSON.stringify(datasource.forecast));
    const service = JSON.parse(JSON.stringify(datasource.service));
    this.chargeFCdataSource = {};
    this.volumeFCdataSource = {};
    this.getforecastDat(
      service,
      this.previousFC.Forecast_Cycle,
      this.extractYrMnth(this.currentFC.FC_Start_Month, 0),
      'previous',
      this.previousFC.C_Description,
      'firstTable',
      this.currentFC.FC_For_Year,
      this.previousFC.Forecast_Year
    );
    this.getforecastDat(
      service,
      this.currentFC.Forecast_Cycle,
      this.extractYrMnth(this.currentFC.FC_Start_Month, 0),
      'projections',
      "Projections generated by ML model  based on Consumption history for year " + this.currentFC.FC_For_Year,
      'firstTable',
      this.currentFC.FC_For_Year,
      this.currentFC.Forecast_Year
    );
    this.getforecastDat(
      service,
      this.currentFC.Forecast_Cycle,
      this.extractYrMnth(this.currentFC.FC_Start_Month, 0),
      'current',
      this.currentFC.C_Description,
      'firstTable',
      this.currentFC.FC_For_Year,
      this.currentFC.Forecast_Year
    );
   
    this.getforecastDat(
      service,
      this.previousFC.Forecast_Cycle,
      this.extractYrMnth(this.currentFC.FC_End_Month, 0),
      'previous',
      this.previousFC.F_Description,
      'secondTable',
      this.currentFC.FC_For_Year + 1,
      this.previousFC.Forecast_Year,// updated to cuirrentFC from Previuos
    );
    this.getforecastDat(
      service,
      this.currentFC.Forecast_Cycle,
      this.extractYrMnth(this.currentFC.FC_End_Month, 0),
      'projections',
      "Projections generated by ML model  based on Consumption history for year " + (this.currentFC.FC_For_Year + 1),
      'secondTable',
      this.currentFC.FC_For_Year + 1,
      this.currentFC.Forecast_Year
    );
    this.getforecastDat(
      service,
      this.currentFC.Forecast_Cycle,
      this.extractYrMnth(this.currentFC.FC_End_Month, 0),
      'current',
      this.currentFC.F_Description,
      'secondTable',
      this.currentFC.FC_For_Year + 1,
      this.currentFC.Forecast_Year
    );
    this.claculateVariance(this.extractYrMnth(this.previousFC.Forecast_Cycle, 0), 'firstTable');
    this.claculateVariance(this.extractYrMnth(this.currentFC.Forecast_Cycle, 0), 'secondTable');
  }
  claculateVariance(Fcyear: any, tableName: string) {
    const volfcYearData = this.volumeFCdataSource[tableName];
    const chargefcYearData = this.chargeFCdataSource[tableName];
    const volVarianceTemp = {};
    const chargeVarianceTemp = {};
    this.months.forEach(ele => {
      volVarianceTemp[ele] = Number(
        (
          (volfcYearData[2] && volfcYearData[2][ele] ? this.convertToNumber(volfcYearData[2][ele]) : 0) -
          (volfcYearData[0] && volfcYearData[0][ele] ? this.convertToNumber(volfcYearData[0][ele]) : 0)
        ).toFixed(0)
      );

      let percentage =
        volVarianceTemp[ele] != 0 ? (volVarianceTemp[ele] / this.convertToNumber(volfcYearData[0][ele])) * 100 : 0;
      percentage = percentage == Infinity || percentage == -Infinity || percentage > 100 ? 100 : percentage;
      volVarianceTemp[ele + 'varPercentage'] = percentage;

      chargeVarianceTemp[ele] = Number(
        (
          (chargefcYearData[2] && chargefcYearData[1][ele] ? this.convertToNumber(chargefcYearData[2][ele]) : 0) -
          (chargefcYearData[0] && chargefcYearData[0][ele] ? this.convertToNumber(chargefcYearData[0][ele]) : 0)
        ).toFixed(0)
      );
      let chargePercentage =
        chargeVarianceTemp[ele] != 0
          ? (chargeVarianceTemp[ele] / this.convertToNumber(chargefcYearData[0][ele])) * 100
          : 0;
      chargePercentage =
        chargePercentage == Infinity || chargePercentage == -Infinity || chargePercentage > 100
          ? 100
          : chargePercentage;
      chargeVarianceTemp[ele + 'varPercentage'] = chargePercentage;
    });
    volVarianceTemp['Year'] = Fcyear;
    volVarianceTemp['label'] = 'Variance';
    volVarianceTemp['tooltip'] = '';

    chargeVarianceTemp['Year'] = Fcyear;
    chargeVarianceTemp['label'] = 'Variance';
    chargeVarianceTemp['tooltip'] = '';

    this.volumeFCdataSource[tableName].push(volVarianceTemp);
    this.chargeFCdataSource[tableName].push(chargeVarianceTemp);
  }
  getPercentage(col, ele) {
    const percent = Math.round(Number(ele[col + 'varPercentage'])) + '%';
    return percent;
  }
  roundoff(value: number) {
    return Math.round(value);
  }

  /**
   * @description: Generate label for forecast data based on year state
   */
  private generateForecastLabel(yearstate: string, Forecast_Year: any, cycle: string, FC_For_Year: any): string {
    if (yearstate === 'projections') {
      return `Projections: ${FC_For_Year}`;
    }
    
    if (yearstate === 'current') {
      const cycleDisplay = this.forecastCycleType?.type === 'Off-cycle' 
        ? 'Update ' 
        : `<b>${Forecast_Year} ${cycle}F</b> `;
      return `Current: ${cycleDisplay}for ${FC_For_Year}`;
    }
    
    return `Prior: <b>${Forecast_Year} ${cycle}F</b> for ${FC_For_Year}`;
  }

  /**
   * @description: Get charge data based on year state
   */
  private getChargeData(data: any, year: string, yearstate: string): any {
    const dataSelectors = {
      'current': () => data.current?.[year]?.charge,
      'projections': () => data.projections?.[year]?.charge,
      'previous': () => data.previous?.[year]?.charge
    };

    const selector = dataSelectors[yearstate] || dataSelectors['previous'];
    const rawData = selector();
    
    return rawData ? this.commaSeparated(rawData) : this.initialVal;
  }

  /**
   * @description: Get volume data based on year state
   */
  private getVolumeData(data: any, year: string, yearstate: string): any {
    const dataSelectors = {
      'current': () => data.current?.[year]?.volume,
      'projections': () => data.projections?.[year]?.volume,
      'previous': () => data.previous?.[year]?.volume
    };

    const selector = dataSelectors[yearstate] || dataSelectors['previous'];
    const rawData = selector();
    
    return rawData ? this.commaSeparated(rawData) : this.initialVal;
  }

  /**
   * @description: Create charge forecast data object
   */
  private createChargeForecastData(year: string, cycle: string, charge: any, yearstate: string, label: string, tooltipMsg: string, tableName: string): any {
    return {
      Year: `${year}(${cycle})`,
      ...charge,
      cycle: yearstate,
      label: label,
      tooltip: tooltipMsg,
      tableName: tableName
    };
  }

  /**
   * @description: Create volume forecast data object
   */
  private createVolumeForecastData(year: string, cycle: string, volume: any, yearstate: string, label: string, tooltipMsg: string, tableName: string): any {
    const yearDisplay = yearstate !== 'projections' 
      ? `${year}(${cycle})` 
      : `${year}(${cycle}) ML`;

    return {
      Year: yearDisplay,
      ...volume,
      cycle: yearstate,
      label: label,
      tooltip: tooltipMsg,
      tableName: tableName
    };
  }

  /**
   * @description: Update data sources with new forecast data
   */
  private updateForecastDataSources(tableName: string, chargefcdata: any, volumefcdata: any): void {
    // Update charge data source
    if (this.chargeFCdataSource[tableName]) {
      this.chargeFCdataSource[tableName].push(chargefcdata);
    } else {
      this.chargeFCdataSource[tableName] = [chargefcdata];
    }
    this.chargeFCdataSource[tableName] = this.calculateTotal(this.chargeFCdataSource[tableName], 'charge');

    // Update volume data source
    if (this.volumeFCdataSource[tableName]) {
      this.volumeFCdataSource[tableName].push(volumefcdata);
    } else {
      this.volumeFCdataSource[tableName] = [volumefcdata];
    }
    this.volumeFCdataSource[tableName] = this.calculateTotal(this.volumeFCdataSource[tableName], 'volume');
  }

  getforecastDat(data, cycle, year, yearstate, tooltipMsg, tableName, FC_For_Year, Forecast_Year) {
    // Generate label for the forecast data
    const label = this.generateForecastLabel(yearstate, Forecast_Year, cycle, FC_For_Year);

    // Get charge and volume data based on year state
    const charge = this.getChargeData(data, year, yearstate);
    const volume = this.getVolumeData(data, year, yearstate);

    // Create forecast data objects
    const chargefcdata = this.createChargeForecastData(year, cycle, charge, yearstate, label, tooltipMsg, tableName);
    const volumefcdata = this.createVolumeForecastData(year, cycle, volume, yearstate, label, tooltipMsg, tableName);

    // Update data sources
    this.updateForecastDataSources(tableName, chargefcdata, volumefcdata);
  }
  extractYrMnth(text, index) {
    if (!text || typeof text !== 'string') {
      console.error('Invalid text passed to extractYrMnth:', text);
      return '';
    }
    const parts = text.split(',');
    if (index >= parts.length) {
      console.error('Index out of bounds in extractYrMnth:', index, parts);
      return '';
    }
    return parts[index];
  }
  commaSeparated(data) {
    if (!data || typeof data !== 'object') {
      return data;
    }
    for (let key in data) {
      if (typeof data[key] == 'number') {
        let formattedValue = data[key]
          .toFixed(0)
          .toLocaleString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        // If the value is negative, add the minus sign back at the beginning
        if (
          this.allowNegative &&
          data[key]
            .toFixed(0)
            .toLocaleString()
            .startsWith('-')
        ) {
          formattedValue = '-' + formattedValue.replace(/^-/, '');
        }
        data[key] = formattedValue;
      }
    }
    return data;
  }

checkEditAccess(): boolean {
  const editFlag =
    (this.isForecastAdmin || this.isForecastSRM)
      ? this.Admin_Edit_TOH == 'yes'
      : this.Edit_TOH == 'yes';

  if (!editFlag) return false;

  const user = (this.loggedInUser ?? '').toString().trim().toLowerCase();
  if (!user) return false;

  const normalizeList = (arr: unknown): string[] =>
    Array.isArray(arr)
      ? arr.map(x => x?.toString().trim().toLowerCase()).filter(Boolean)
      : [];

  const aoAd = normalizeList(this.AO_AD_Edit);
  const faSfa = normalizeList(this.FA_SFA_Edit);
  const so = normalizeList(this.SO_Edit);

  // Use a Set for fast membership checks
  const editableUsers = new Set<string>([...aoAd, ...faSfa, ...so]);
  return editableUsers.has(user);
}


  getForecastOwnerDetails() {
    this.showLoader = true;
    const adminRole = this.sharedAuthService.isForecastAdmin();
    const srmRole = this.sharedAuthService.getForecastAccessDetails('SRM');
    this.isForecastAdmin = adminRole.length > 0 ? true : false;
    this.isForecastSRM = srmRole.length > 0 ? true : false;
      
  }

  editFC(mode) {
    if (mode == 'edit') {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.width = '400px';
      dialogConfig.hasBackdrop = true;
      dialogConfig.minHeight = '200px';
      dialogConfig.height = 'auto';
      dialogConfig.autoFocus = false;
      dialogConfig.data = {
        title: 'Discard Confirmation!',
        subTitle: 'Are you sure to discard the change(s)?',
        buttonName: 'Continue'
      };

      const dialogRef = this.dialog.open(DailogModalComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(result => {
        if (result.data != 'cancel') {
          this.formatFCSource(this.fcDataSource);
          this.resetData();
          this.updategraph(this.fcDataSource);
        }
      });
    } else if (mode == 'normal') {
      this.currentMode = 'edit';
    }
  }
  resetData() {
    this.currentMode = 'normal';
    this.valueExceedLmt = [];
    this.temp = {};

    if (this.fcDataSource) {
      try {
        this.APIresponse = JSON.parse(JSON.stringify(this.fcDataSource));
      } catch (error) {
        console.error('Error parsing fcDataSource:', error);
        this.APIresponse = {}; // Fallback to an empty object
      }
    } else {
      console.warn('fcDataSource is undefined or null.');
      this.APIresponse = {}; // Fallback to an empty object
    }

    this.comments = this.dataSource?.current?.[this.currentYear]?.Comments || '';
    this.newcomments = '';
  }
  convertToNumber(input) {
    if (typeof input == 'number') {
      return Math.round(Number(input));
    } else {
      input = input
        ? this.allowNegative
          ? input.split('.')[0].replace(/(?!^)-|[^0-9-]/g, '')
          : input.split('.')[0].replace(/[^0-9]*/g, '')
        : 0;
      return Math.round(Number(input));
    }
  }

  private processInputValue(val: any): string {
    const processedVal = val || '0';
    return this.allowNegative
      ? processedVal.split('.')[0].replace(/(?!^)-|[^0-9-]/g, '')
      : processedVal.split('.')[0].replace(/[^0-9]*/g, '');
  }

  private extractYearAndCycle(data: any): { year: string; forecastCycle: string } {
    const year = data.Year.split('(')[0];
    const forecastCycle = data.Year.split('(')[1]?.replace(')', '') || '';
    return { year, forecastCycle };
  }

  private calculateChargeValue(val: string, year: string): string {
    const rate = this.dataSource.current[year]?.CY_Rate || 0;
    return (Number(val) * (rate ? rate : 0))
      .toFixed(0)
      .toLocaleString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  private updateChargeVariance(data: any, col: string, varianceIndex: number): void {
    this.chargeFCdataSource[data.tableName][varianceIndex][col] =
      this.convertToNumber(this.chargeFCdataSource[data.tableName][2][col]) -
      this.convertToNumber(this.chargeFCdataSource[data.tableName][0][col]);
  }

  private updateVolumeVariance(data: any, val: string, col: string, varianceIndex: number): void {
    this.volumeFCdataSource[data.tableName][varianceIndex][col] =
      this.convertToNumber(val) - this.convertToNumber(this.volumeFCdataSource[data.tableName][0][col]);
  }

  private calculatePercentage(numerator: number, denominator: number): number {
    if (numerator === 0) return 0;
    const percentage = (numerator / denominator) * 100;
    return (percentage === Infinity || percentage === -Infinity || percentage > 100) ? 100 : percentage;
  }

  private updateChargePercentage(data: any, col: string, varianceIndex: number): void {
    const chargeVariance = this.chargeFCdataSource[data.tableName][varianceIndex][col];
    const baseChargeValue = this.convertToNumber(this.chargeFCdataSource[data.tableName][0][col]);
    const chargePercentage = this.calculatePercentage(chargeVariance, baseChargeValue);
    this.chargeFCdataSource[data.tableName][varianceIndex][col + 'varPercentage'] = chargePercentage;
  }

  private updateVolumePercentage(data: any, col: string, varianceIndex: number): void {
    const volumeVariance = this.volumeFCdataSource[data.tableName][varianceIndex][col];
    const baseVolumeValue = this.convertToNumber(this.volumeFCdataSource[data.tableName][0][col]);
    const volumePercentage = this.calculatePercentage(volumeVariance, baseVolumeValue);
    this.volumeFCdataSource[data.tableName][varianceIndex][col + 'varPercentage'] = volumePercentage;
  }

  private validateValueLimits(val: string, col: string, year: string): void {
    const colIndex = this.valueExceedLmt.indexOf(col + year);
    const yearData = this.dataSource.current[year];
    
    if (yearData?.start_limit && yearData?.end_limit) {
      const numVal = Number(val);
      const isWithinLimits = yearData.start_limit <= numVal && numVal <= yearData.end_limit;
      
      if (!isWithinLimits) {
        if (colIndex === -1) {
          this.valueExceedLmt.push(col + year);
        }
      } else {
        if (colIndex > -1) {
          this.valueExceedLmt.splice(colIndex, 1);
        }
      }
    }
  }

  private manageTempData(val: string, col: string, year: string): void {
    const originalValue = this.fcDataSource?.service?.current?.[year]?.volume?.[col]
      ? JSON.parse(JSON.stringify(this.fcDataSource.service.current[year].volume[col]))
      : this.initialVal[col];

    if (this.temp[year]) {
      if (originalValue == val) {
        if (Object.keys(this.temp[year]).length > 1) {
          delete this.temp[year][col];
        } else {
          delete this.temp[year];
        }
      } else {
        this.temp[year][col] = Number(val);
      }
    } else {
      this.temp[year] = { [col]: Number(val) };
    }
  }

  private updateAPIResponseData(data: any, val: string, col: string, year: string, forecastCycle: string, index: number): void {
    const obj = this.APIresponse.forecast.find(o => o.Forecast_Cycle == forecastCycle);
    const dataArr = obj.Previous.toLowerCase() == 'no' 
      ? this.APIresponse.service.current 
      : this.APIresponse.service.previous;
    
    dataArr[year]['volume'][col] = Number(val);
    dataArr[year]['charge'][col] = this.convertToNumber(this.chargeFCdataSource[data.tableName][index][col]);
  }

  onChange(val, col, data, event) {
    if (event.key !== 'Tab') {
      const processedVal = this.processInputValue(val);
      const { year, forecastCycle } = this.extractYearAndCycle(data);
      const index = this.chargeFCdataSource[data.tableName].findIndex(x => x.Year == data.Year && x.cycle == data.cycle);
      const varianceIndex = this.chargeFCdataSource[data.tableName].findIndex(x => x.label == 'Variance');
      
      // Update charge value
      this.chargeFCdataSource[data.tableName][index][col] = this.calculateChargeValue(processedVal, year);
      
      // Update variance calculations
      this.updateChargeVariance(data, col, varianceIndex);
      this.updateVolumeVariance(data, processedVal, col, varianceIndex);
      
      // Update percentage calculations
      this.updateChargePercentage(data, col, varianceIndex);
      this.updateVolumePercentage(data, col, varianceIndex);
      
      // Validate value limits
      this.validateValueLimits(processedVal, col, year);
      
      // Manage temporary data
      this.manageTempData(processedVal, col, year);
      
      // Update API response data
      this.updateAPIResponseData(data, processedVal, col, year, forecastCycle, index);
      
      // Update totals and refresh graph
      this.updateTotal(data, index);
      this.updategraph(this.APIresponse);
    }
  }

  // Update the total value for volume and also for charge
  updateTotal(data, index) {
    if(this.volumeFCdataSource[data.tableName] && this.chargeFCdataSource[data.tableName]){
      const updatedArr = this.calculateTotal([this.volumeFCdataSource[data.tableName][index]], 'volume');
      if (updatedArr.length > 0) {
        const { total, orgTotal } = updatedArr[0];
        Object.assign(this.volumeFCdataSource[data.tableName][index], { total, orgTotal });
      }
      const updatedChargeArr = this.calculateTotal([this.chargeFCdataSource[data.tableName][index]], 'charge');
      if (updatedChargeArr.length > 0) {
        const { total, orgTotal } = updatedChargeArr[0];
        Object.assign(this.chargeFCdataSource[data.tableName][index], { total, orgTotal });
      }
    }else{
      console.log("Invalid TableName provided for updating total");
    }
   
  }

  showAttestationPopup() {
    if (!this.dataSource || !this.dataSource.current || !this.currentYear) {
      this.toaster.error('Data is not available for attestation', '', {
        timeOut: 10000,
        positionClass: 'toast-top-center'
      });
      return;
    }
  
    this.decomcount = 0;
    const editedYrs = Object.keys(this.temp);
    if (this.masterData?.decom_date != null) {
      editedYrs.forEach(yr => {
        if (Number(yr) > this.decomStartYear) {
          const months = Object.keys(this.temp[yr]);
          months.forEach(element => {
            this.temp[yr][element] != 0 ? this.decomcount++ : this.decomcount;
          });
        } else if (Number(yr) == this.decomStartYear) {
          const edittedmonths = Object.keys(this.temp[yr]);
          const decomFc = this.decomMonths.filter(value => edittedmonths.includes(value));
          decomFc.forEach(element => {
            this.temp[yr][element] != 0 ? this.decomcount++ : this.decomcount;
          });
        }
      });
    }
    this.newcomments = '';
    this.comments = this.dataSource.current[this.currentYear].Comments
      ? this.dataSource.current[this.currentYear].Comments
      : '';
    this.commentsPlaceholderText =
      this.valueExceedLmt.length > 0 || this.decomcount > 0
        ? 'Comments are mandatory to proceed further.'
        : 'Comments are optional, if needed, enter and click continue ';
    this.attestation_popup_title =
      this.masterData?.decom_date != null && this.decomcount > 0
        ? 'Forecast added for post planned Decommisioned Months, Please add comments to continue'
        : this.valueExceedLmt.length > 0
        ? 'Forecast added is greater/lesser than the limit, Please add comments to continue'
        : 'Click Continue to Save';
    this.attestationPopup.show();
  }

  hideAttestationPopup() {
    this.attestationPopup.hide();
  }

  submitForecast() {
    const editedYrs = Object.keys(this.temp);
    const reqPayload = {
      app_id: this.dataSource.app_id,
      service: this.dataSource.service,
      current: {}
    };

    reqPayload.current[this.currentYear] = {
      Comments: this.newcomments,
      Attested_By: this.getAttestedDetails(this.dataSource.current[this.currentYear]),
      volume: {}
    };
    reqPayload.current[this.currentYear + 1] = {
      Comments: this.newcomments,
      Attested_By: this.getAttestedDetails(this.dataSource.current[this.currentYear + 1]),
      volume: {}
    };
    reqPayload.current[this.currentYear - 1] = {
      Comments: this.newcomments,
      Attested_By: this.getAttestedDetails(this.dataSource.current[this.currentYear - 1]),
      volume: {}
    };

    if (editedYrs.length) {
      editedYrs.forEach(yr => {
        const edittedYear = yr.split('(')[0];
        reqPayload.current[edittedYear]['volume'] = this.temp[edittedYear];
      });
    }
    this.updateFC(reqPayload);
    this.attestationPopup.hide();
  }

  updateFC(reqPayload) {
    this.showLoader = true;
    this.maintenanceService.updateFCDetails(reqPayload).subscribe(
      (response: any) => {
        this.showSuccessMsg(response.message);
        this.getServiceDtl();
        this.resetData();
      },
      error => {
        this.showErrMsg(error);
        this.formatFCSource(this.fcDataSource);
        this.resetData();
        this.updategraph(this.fcDataSource);
      }
    );
  }

  getAttestedDetails(data) {
    if (!data) {
      console.error('Data is undefined or null in getAttestedDetails');
      return null;
    }

    const user = (this.loggedInUser ?? '').toString().trim().toLowerCase();
    if (!user) {
      console.error('loggedInUser is undefined or empty');
      return null;
    }

    const normalizeList = (arr: unknown): string[] =>
      Array.isArray(arr)
        ? arr.map(x => x?.toString().trim().toLowerCase()).filter(Boolean)
        : [];

    // Normalize the edit lists
    const aoAdEdit = data.AO_AD_Edit 
      ? normalizeList(data.AO_AD_Edit.split(','))
      : [];
    const soEdit = data.SO_Edit 
      ? normalizeList(data.SO_Edit.split(','))
      : [];
    const faSfaEdit = data.FA_SFA_Edit 
      ? normalizeList(data.FA_SFA_Edit.split(','))
      : [];

      console.log("user value.........................................." , user);
      console.log("AO_AD_Edit list..........................................", aoAdEdit);
      console.log("SO_Edit list..........................................", soEdit);
      console.log("FA_SFA_Edit list..........................................", faSfaEdit);
    // Check membership using case-insensitive comparison
    if (aoAdEdit.includes(user)) {
      return 'AO_AD';
    } else if (soEdit.includes(user)) {
      return 'SO';
    } else if (faSfaEdit.includes(user)) {
      return 'FA_SFA';
    }

    return null;
  }

  gettextcolor(element, col) {
    if (element.cycle == 'previous' && !Object.keys(this.dataSource.previous).includes(element.Year.split('(')[0])) {
      return 'orange-text';
    } else if (col !== 'Year' && element.cycle == 'previous' && this.previousFC) {
      return this.isDateInRange(
        col + element.Year.split('(')[0],
        this.previousFC?.FC_Start_Month,
        this.previousFC?.FC_End_Month
      )
        ? 'orange-text'
        : 'black-text';
    } else if (col !== 'Year' && element.cycle == 'current' && this.currentFC) {
      return this.isDateInRange(
        col + element.Year.split('(')[0],
        this.currentFC?.FC_Start_Month,
        this.currentFC?.FC_End_Month
      )
        ? 'blue-text'
        : 'black-text';
    }else if (col !== 'Year' && element.cycle == 'projections' && this.currentFC) {
      return this.isDateInRange(
        col + element.Year.split('(')[0],
        this.currentFC?.FC_Start_Month,
        this.currentFC?.FC_End_Month
      )
        ? 'purple-text'
        : 'black-text';
    } else {
      return 'black-text';
    }
  }
  enableEdit(element, col) {
    if (col !== 'Year' && element.cycle != 'previous' && element.cycle !='projections' && this.currentFC) {
      return this.isDateInRange(
        col + element.Year.split('(')[0],
        this.currentFC.FC_Start_Month,
        this.currentFC.FC_End_Month
      );
    } else {
      return false;
    }
  }
  apptoggle(event) {
    this.showCharge = event.checked;
    this.updategraph(this.APIresponse);
  }

  isDateInRange(monthYear: string, startMonthYear: string, endMonthYear: string): boolean {
    const [month, year] = monthYear.split(/(?<=\D)(?=\d)/);
    const [startMonth, startYear] = startMonthYear.split(/(?<=\D)(?=\d)/);
    const [endMonth, endYear] = endMonthYear.split(/(?<=\D)(?=\d)/);
    const date = new Date(`${year}-${month}-01`);
    const startDate = new Date(`${startYear}-${startMonth}-01`);
    const endDate = new Date(`${endYear}-${endMonth}-01`);
    return date >= startDate && date <= endDate;
  }

  showErrMsg(err: any) {
    this.showLoader = false;
    if (err.error && err.error.message) {
      this.toaster.error(err.error.message, '', {
        timeOut: 10000,
        positionClass: 'toast-top-center'
      });
    }
  }

  showSuccessMsg(msg: any) {
    this.showLoader = false;
    if (msg) {
      this.toaster.success(msg, '', {
        timeOut: 10000,
        positionClass: 'toast-top-center'
      });
    }
  }
  
  formatDataForGraph(response) {
    const currentYear = this.currentYear;
    const maxMin = { maxValue: 0, minValue: 0 };
    
    // Process actual data
    const arr = this.processActualData(response.service.current, currentYear, maxMin);
    
    // Process forecast data
    this.processForecastData(response, currentYear, arr, maxMin);
    
    // Return formatted result
    return {
      arr: arr,
      maxRange: Math.round(maxMin.maxValue),
      minValue: Math.round(maxMin.minValue)
    };
  }

  private getMonthNumber(monthName: string, currentYear: number): number {
    return new Date(`${monthName} 1, ${currentYear}`).getMonth() + 1;
  }

  private getAvailableDataInfo(): { availableYr: string; availableMnth: string } {
    const parts = this.availableData.split(' ');
    return {
      availableMnth: parts[0],
      availableYr: parts[1]
    };
  }

  private isDataAvailable(year: string, month: string, availableYr: string, availableMnth: string): boolean {
    return year < availableYr || 
           (year == availableYr && this.months.indexOf(month) <= this.months.indexOf(availableMnth));
  }

  private updateMinMaxValues(value1: number, value2: number, currentMax: { value: number }, currentMin: { value: number }): void {
    const maxVal = Math.max(value1 || 0, value2 || 0);
    const minVal = Math.min(value1 || 0, value2 || 0);
    
    if (maxVal > currentMax.value) {
      currentMax.value = maxVal;
    }
    if (minVal < currentMin.value) {
      currentMin.value = minVal;
    }
  }

  private getDataArrayType(dataSource: any, year: string): any {
    return this.showCharge ? dataSource[year]['charge'] : dataSource[year]['volume'];
  }

  /**
   * @description: Check if month data is valid and available
   */
  private isMonthDataValid(month: string, year: string, availableYr: string, availableMnth: string): { valid: boolean; monthNum: number } {
    const date = new Date(`${month} 1, ${year}`);
    const monthNum = date.getMonth() + 1;
    const isValid = !isNaN(monthNum) && this.isDataAvailable(year, month, availableYr, availableMnth);
    return { valid: isValid, monthNum };
  }

  /**
   * @description: Update min/max values for graph rendering
   */
  private updateGraphMinMaxValues(value: any, maxMin: { maxValue: number; minValue: number }): void {
    this.updateMinMaxValues(value, value, { value: maxMin.maxValue }, { value: maxMin.minValue });
    maxMin.maxValue = Math.max(maxMin.maxValue, value || 0);
    maxMin.minValue = Math.min(maxMin.minValue, value || 0);
  }

  /**
   * @description: Create actual data point object for graph
   */
  private createActualDataPoint(dateStr: string, value: any): any {
    const roundedValue = value != null ? Math.round(value) : null;
    return {
      d: dateStr,
      actuals: roundedValue,
      projections: roundedValue,
      forecast1: roundedValue,
      forecast2: roundedValue
    };
  }

  /**
   * @description: Process month data within a year
   */
  private processMonthData(dataArr: any, year: string, availableYr: string, availableMnth: string, maxMin: { maxValue: number; minValue: number }): any[] {
    const monthResults = [];
    
    for (const month in dataArr) {
      const { valid, monthNum } = this.isMonthDataValid(month, year, availableYr, availableMnth);
      
      if (valid) {
        const value = dataArr[month];
        const dateStr = `${year}-${monthNum}-01`;
        
        this.updateGraphMinMaxValues(value, maxMin);
        monthResults.push(this.createActualDataPoint(dateStr, value));
      }
    }
    
    return monthResults;
  }

  private processActualData(actuals: any, currentYear: number, maxMin: { maxValue: number; minValue: number }): any[] {
    const arr = [];
    const { availableYr, availableMnth } = this.getAvailableDataInfo();

    for (const year in actuals) {
      if (currentYear >= Number(year)) {
        const dataArr = this.getDataArrayType(actuals, year);
        const monthData = this.processMonthData(dataArr, year, availableYr, availableMnth, maxMin);
        arr.push(...monthData);
      }
    }
    
    return arr;
  }

  private getForecastDataArray(forecastObj: any, serviceData: any): { dataArr: any; prevFC: boolean } {
    if (forecastObj.Previous.toLowerCase() == 'yes') {
      return { dataArr: serviceData.service.previous, prevFC: true };
    } else {
      return { dataArr: serviceData.service.current, prevFC: false };
    }
  }

  private createForecastDataObject(dateStr: string, projec: number, value: number, prevFC: boolean): any {
    return {
      d: dateStr,
      actuals: null,
      projections: projec != null ? Math.round(projec) : null,
      forecast1: prevFC ? Math.round(value) : null,
      forecast2: !prevFC ? Math.round(value) : null
    };
  }

  private updateExistingDataPoint(arr: any[], index: number, projec: number, value: number, prevFC: boolean): void {
    const prop = prevFC ? 'forecast1' : 'forecast2';
    arr[index]['projections'] = projec != null ? Math.round(projec) : null;
    arr[index][prop] = Math.round(value);
  }

  // green (current forecast) should only plot from its own FC_Start_Month, not the generic actuals cutoff
  private isBeforeForecastStart(year: number, month: string, fcStartMonth: string, currentYear: number): boolean {
    const startYear = Number(this.extractYrMnth(fcStartMonth, 0));
    const startMonthNum = this.getMonthNumber(this.extractYrMnth(fcStartMonth, 1), currentYear);
    const monthNum = this.getMonthNumber(month, currentYear);
    return year < startYear || (year === startYear && monthNum < startMonthNum);
  }


  private processForecastData(response: any, currentYear: number, arr: any[], maxMin: { maxValue: number; minValue: number }): void {
    const { availableYr, availableMnth } = this.getAvailableDataInfo();
    
    for (let i = 0; i <= response.forecast.length - 1; i++) {
      const obj = response.forecast[i];
      const { dataArr, prevFC } = this.getForecastDataArray(obj, response);
      const projectionsData = response.service.projections;
      
      for (const year in dataArr) {
        const ye = Number(year);
        const result = this.getDataArrayType(dataArr, year);
        const projectionsResult = this.showCharge 
          ? projectionsData[year]?.charge 
          : projectionsData[year]?.volume;
        
        for (const month in result) {
          if (this.isDataAvailable(ye.toString(), month, availableYr, availableMnth)) {
            continue;
          }
          if (!prevFC && this.isBeforeForecastStart(ye, month, obj.FC_Start_Month, currentYear)) {
            continue;
          }
          
          const value = result[month];
          const projec = projectionsResult ? projectionsResult[month] : null;
          const dateStr = `${year}-${this.getMonthNumber(month, currentYear)}-01`;
          
          maxMin.maxValue = Math.max(maxMin.maxValue, value || 0, projec || 0);
          maxMin.minValue = Math.min(maxMin.minValue, value || 0, projec || 0);
          
          const existingIndex = arr.findIndex(x => x.d === dateStr);
          if (existingIndex !== -1) {
            this.updateExistingDataPoint(arr, existingIndex, projec, value, prevFC);
          } else {
            arr.push(this.createForecastDataObject(dateStr, projec, value, prevFC));
          }
        }
      }
    }
  }

  navigateToTeams() {
    const url =
      'https://teams.microsoft.com/l/channel/19%3A04d331c020844c8195d3b5367c69a144%40thread.tacv2/TechOps%20Hub%20Infra%20Forecast%20Management?groupId=2ddaff3a-b209-451a-8405-5c0530c43e91&tenantId=db05faca-c82a-4b9d-b9c5-0f64b6755421';
    window.open(url, '_blank');
  }

  //Function to open Report Link
  openReportLink() {
    let filters = [];
    const queryParams = this.ReportsService.getWindowLocationSearch();
    if (queryParams) {
      try {
        Object.keys(queryParams).forEach(key => {
          if (key == 'service') filters.push({ service: this.dataSource?.SV_Desc });
          else if (key == 'appId') filters.push({ appId: queryParams[key]+' '+this.dataSource?.app_name });
          else filters.push({ [key]: queryParams[key] });
        });
      } catch (error) {
        console.error('Error parsing filters from query params:', error);
      }
    }
    let url = this.ReportsService.createDynamicReport(filters, 'Infra Consumption Details Report', 'Portfolio hub','3YrsByApp');
    const src = window.location.origin + url;
    const sanitizedUrl = this.sanitizer.sanitize(SecurityContext.URL, src) || '';
    window.open(sanitizedUrl, '_blank');
  }
  getForeCastCycleType(forecastCycleData) {
    const dates = this.convertDatesToCentralTime(forecastCycleData);
    this.forecastCycleType = this.determineForecastCycleType(dates);
  }

  getCentralDate(): string {
    return new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/Chicago',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).format(new Date());
  }

  private convertDatesToCentralTime(forecastCycleData: any): any {
    // Use Central Time for current date regardless of user's browser locale
    const centralDateStr = this.getCentralDate();

    return {
      current: centralDateStr ? centralDateStr : null,
      start: forecastCycleData.Start_Date ? forecastCycleData.Start_Date : null,
      emailStart: forecastCycleData.Email_Start_Date ? forecastCycleData.Email_Start_Date : null,
      end: forecastCycleData.End_date ? forecastCycleData.End_date : null,
      adminEnd: forecastCycleData.Admin_End_Date ? forecastCycleData.Admin_End_Date : null
    };
  }

  private toCentralTime(input: string | Date): Date | null {
    if (!input) return null;
    // Handle Date objects (from tests) — strip time, keep date only
    if (input instanceof Date) {
      return new Date(input.getFullYear(), input.getMonth(), input.getDate());
    }
    // Handle YYYY-MM-DD strings (from DB) — parse directly to avoid UTC midnight issue
    const [year, month, day] = (input as string).split('-').map(Number);
    return new Date(year, month - 1, day); // midnight local time
  }

  private determineForecastCycleType(dates: any): any {
    if (this.isOffCyclePeriod(dates)) {
      return this.buildOffCycleType();
    }
    
    if (this.isInCyclePeriod(dates)) {
      return this.buildInCycleType(dates);
    }
    
    if (this.isClosedCyclePeriod(dates)) {
      return this.buildClosedCycleType();
    }
    
    return null;
  }

  private isOffCyclePeriod(dates: any): boolean {
    return dates.start && dates.emailStart && 
           dates.current >= dates.start && 
           dates.current < dates.emailStart;
  }

  private isInCyclePeriod(dates: any): boolean {
    const effectiveEndDate = this.getEffectiveEndDate(dates);
    return dates.emailStart && effectiveEndDate && 
           dates.current >= dates.emailStart && 
           dates.current <= effectiveEndDate;
  }

  private isClosedCyclePeriod(dates: any): boolean {
    return dates.end && dates.current > dates.end;
  }

  private getEffectiveEndDate(dates: any): Date | null {
    return (this.isForecastAdmin || this.isForecastSRM) ? dates.adminEnd : dates.end;
  }

  private buildOffCycleType(): any {
    if (this.masterData?.Attested_By_Offc != null) {
      return {
        type: 'Off-cycle',
        msg: 'Previous updates are saved.',
        submsg: "You’ll receive a notification to attest later."
      };
    }
    return {
      type: 'Off-cycle',
      msg: 'Click on ',
      msg2: 'Edit',
      msg3: ' to update forecast.',
      submsg: "You’ll receive a notification to attest later."
    };
  }

  private buildInCycleType(dates: any): any {
    const countDown = this.getCountDownDays(dates.end, dates.adminEnd);
    const dayText = countDown > 1 ? 'days' : 'day';
    const submsg = `${countDown} ${dayText} remaining!`;
    
    return {
      type: 'In-cycle',
      ...this.getInCycleMessage(),
      submsg
    };
  }

  private getInCycleMessage(): any {
    const hasOffcycle = this.masterData?.Attested_By_Offc != null;
    const hasIncycle = this.masterData?.Attested_By != null;
    
    if (hasOffcycle && hasIncycle) {
      return { msg: 'Forecast is updated and attested. You can still make changes.' };
    }
    
    if (hasOffcycle && !hasIncycle) {
      return { msg: 'Previous updates are saved. You must update/attest again.' };
    }
    
    if (!hasOffcycle && hasIncycle) {
      return { msg: 'Forecast is updated and attested. You can still make changes.' };
    }
    
    return {
      msg: 'Click on ',
      msg2: 'Edit',
      msg3: ' to update and attest forecast.'
    };
  }

  private buildClosedCycleType(): any {
    return {
      type: 'Closed-cycle',
      msg: 'Forecast portal is closed',
      submsg: 'Edits are no longer allowed.'
    };
  }

  //Function to get the countdown days based on endDate and adminEndDate include both the dates
  getCountDownDays(endDate, adminEndDate) {

    if (this.isForecastAdmin || this.isForecastSRM) {
      // For Admin and SRM, use adminEndDate
      if (!adminEndDate) return null;
      return this.daysRemaining(adminEndDate); // Including both current day and end date
    } else {
      // For others, use endDate
      if (!endDate) return null;
      return this.daysRemaining(endDate); // Including both current day and end date
    }
  }
  daysRemaining(date: string | Date) {
    const currentDate = this.getCentralDate();
    const [ty, tm, td] = currentDate.split('-').map(Number);
    const today = new Date(ty, tm - 1, td);

    let endDate: Date;
    if (typeof date === 'string') {
      const [fy, fm, fd] = date.split('-').map(Number);
      endDate = new Date(fy, fm - 1, fd);
    } else {
      endDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    }

    const timeDiff = endDate.getTime() - today.getTime();
    const daysDiff = Math.abs(Math.ceil(timeDiff / (1000 * 60 * 60 * 24)));
    return daysDiff + 1; // Including both the current day and the end date
  }

  copyToCurrent(val){
    const availableMnth = this.availableData.split(' ')[0];
    const availableYr = this.availableData.split(' ')[1];
    let availabledataMonths = JSON.parse(JSON.stringify(this.months));
    let yr = val.Year.split('(')[0];
    if(yr== availableYr){
      availabledataMonths = availabledataMonths.splice(availabledataMonths.indexOf(availableMnth)+1,12);
    }
    for(let mnths of availabledataMonths){
      this.volumeFCdataSource[val['tableName']][2][mnths] = this.convertToNumber(val[mnths]);
      this.onChange(val[mnths],mnths,this.volumeFCdataSource[val['tableName']][2],{key:''});
    }
  }

  getCopyIconToolTipMsg(element){
    let tooltipMsg  = element.cycle == 'projections' ? 'Copy projections to user entered forecast' : 'Copy prior forecast to user entered forecast';
    return tooltipMsg;
  }
}
